import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Accordion } from "react-bootstrap";
import Dropzone from "react-dropzone-uploader";
import { useForm } from "react-hook-form";
import { translate } from "react-switch-lang";
import { Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Media, Row } from "reactstrap";
import { default as Swal, default as SweetAlert } from "sweetalert2";
import pdfLogo from "../../../../assets/images/logo/pdfImage.png";
import wordLogo from "../../../../assets/images/logo/wordImage.png";
import { CourseDto } from "../../../../models/courseDto";
import { CoursesListDisplayType } from "../../../../models/coursesListDisplayType";
import { Language } from "../../../../models/languageDto";
import { ModuleDto } from "../../../../models/moduleDto";
import { TrainingPathTanslationDto } from "../../../../models/trainingPathTranslationDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import ButtonComponent from "../components/buttonComponent";
import CourseList from "../course/course";
import styles from "./training-path-manager.module.scss";

const TrainingPathTranslationForm: React.FC<{
  t: (key: string) => {};
  trainingTranslation: TrainingPathTanslationDto;
  language: Language;
  activeStep: number;
  isAllLanguages: boolean;
  disabled: boolean;
  currentSupportName: string;
  handleSupportChange: (support: any) => void;
  handleBack: () => void;
  handleNext: () => void;
  addTrainingPathTranslation: (trainingPathTanslationDto: TrainingPathTanslationDto) => void;
}> = props => {
  const OLD_TRAINING_PATH = props.trainingTranslation;
  const { keycloak } = useKeycloak();
  const httpClient = useHttpClient(keycloak.authenticated);
  const [modules, setModules] = useState<ModuleDto[]>([]);
  const [moduleTitle, setModuleTitle] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isTrainingPathUpdate, setIsTrainingPathUpdate] = useState(false);
  const [updatedModule, setUpdatedModule] = useState<ModuleDto>(new ModuleDto());
  const [sectionAddModule, setSectionAddModule] = useState(false);
  const [updateButton, setUpdateButton] = useState("");
  const [currentSupportName, setCurrentSupportName] = useState("");

  const {
    register,
    getValues,
    formState: { errors, isValid },
  } = useForm<TrainingPathTanslationDto>({ mode: "onChange", defaultValues: OLD_TRAINING_PATH || {} });

  useEffect(() => {
    props.trainingTranslation && props.trainingTranslation.id ? setIsTrainingPathUpdate(true) : setIsTrainingPathUpdate(false);
    if (props.currentSupportName) {
      setCurrentSupportName(props.currentSupportName);
    } else {
      setCurrentSupportName(props.trainingTranslation ? getSupportFileOriginalName(props.trainingTranslation.supportPath) : null);
    }
    setModules(props.trainingTranslation?.moduleList ? props.trainingTranslation.moduleList : ([] as ModuleDto[]));
    // eslint-disable-next-line
  }, []);

  const addCourseToModule = (moduleID: number, courseData: CourseDto) => {
    modules.forEach(module => {
      if (module.id === moduleID) {
        module.courseDtoList.push(courseData);
      }
    });
    setModules(() => modules.concat());
  };

  const updateCourseInModuleList = (moduleID: number, courseData: CourseDto) => {
    modules.forEach(module => {
      if (module.id === moduleID) {
        let updateItem = module.courseDtoList.find(course => course.id === courseData.id);
        let index = module.courseDtoList.indexOf(updateItem);
        module.courseDtoList[index] = courseData;
      }
    });
    setModules(() => modules.concat());
  };

  const deleteCourseInModuleList = (courseID: number, moduleID: number) => {
    let module = modules.find(module => module.id === moduleID);
    let moduleIndex = modules.indexOf(module);
    let deletedItem = module.courseDtoList.find(course => course.id === courseID);
    let index = modules[moduleIndex].courseDtoList.indexOf(deletedItem);
    modules[moduleIndex].courseDtoList.splice(index, 1);
    setModules(() => modules.concat());
  };

  const reloadData = () => {
    getModuleListByTrainingPathTranslationID();
  };

  const getModuleListByTrainingPathTranslationID = async () => {
    if (props.trainingTranslation && props.trainingTranslation?.id) {
      await httpClient.current?.get(`/module/trainingPathTranslation/${props.trainingTranslation?.id}`).then(response => {
        setModules(response?.data as ModuleDto[]);
      });
    }
  };

  function getModuleDuration(moduleId: number) {
    var hours: number = 0;
    var minuts: number = 0;
    let coursesList = modules.filter(module => module.id === moduleId)[0].courseDtoList;

    coursesList.forEach(course => {
      hours = hours + course.courseHours;
      minuts = minuts + course.courseMinutes;
    });
    hours += Math.floor(minuts / 60);
    minuts = minuts % 60;
    return getCourseTimeString(hours, minuts);
  }

  const getCourseTimeString = (courseHours: number, courseMinuts: number) => {
    if (courseHours.toString() === "0") {
      return courseMinuts + " min ";
    } else if (courseMinuts.toString() === "0") {
      return courseHours + " h ";
    } else {
      return courseHours + " h " + courseMinuts + " min ";
    }
  };

  const preSaveTrainingPathTranslation = () => {
    let trainingPathTranslation = getValues();
    trainingPathTranslation.language = Language[props.language];
    trainingPathTranslation.moduleList = modules;
    if (props.trainingTranslation && !props.trainingTranslation.supportPath) {
      trainingPathTranslation.supportPath = null;
    }
    props.addTrainingPathTranslation(trainingPathTranslation);
  };

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;
    const items = Array.from(modules);

    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setModules(items);
  };

  const changeClassName = async (id: any) => {
    let arrayList = document.getElementsByClassName("fa fa-chevron-up");
    for (let i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id !== id) {
        arrayList[i].className = "fa fa-chevron-down";
      }
    }
  };

  const handleClicked = async (e: any) => {
    await changeClassName(e.target.id);
    if (e.target.className === "fa fa-chevron-up") {
      e.target.className = "fa fa-chevron-down";
    } else if (e.target.className === "fa fa-chevron-down") {
      e.target.className = "fa fa-chevron-up";
    }
  };

  const titleClicked = async (id: string) => {
    await changeClassName(id);
    let e = document.getElementById(id);
    if (e?.className === "fa fa-chevron-up") {
      e.className = "fa fa-chevron-down";
    } else if (e?.className === "fa fa-chevron-down") {
      e.className = "fa fa-chevron-up ";
    }
  };

  const deleteModule = async (id: number) => {
    if (isTrainingPathUpdate) {
      httpClient.current?.delete(`/module/${id}`).then(() => {
        getModuleListByTrainingPathTranslationID();
        setSectionAddModule(false);
      });
    } else {
      await setModules(modules.filter(m => m.id !== id));
      setSectionAddModule(false);
      setIsUpdate(false);
    }
  };

  const updateModule = () => {
    if (isTrainingPathUpdate) {
      let module: ModuleDto = updatedModule;
      module.title = moduleTitle;
      httpClient.current
        ?.put(`/module`, module, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          setModuleTitle("");
          setIsUpdate(false);
          setSectionAddModule(false);
        });
    } else {
      let moduleUpdated: ModuleDto = updatedModule;
      moduleUpdated.title = moduleTitle;
      modules.forEach(module => {
        if (module.id === moduleUpdated.id) {
          module = moduleUpdated;
        }
      });
      setIsUpdate(false);
      setSectionAddModule(false);
      setModuleTitle("");
    }
  };

  const addNewModule = () => {
    if (moduleTitle.length > 2 && isTrainingPathUpdate) {
      let order = modules.length;
      let module = new ModuleDto();
      module.title = moduleTitle;
      module.orderOnPath = order++;
      module.trainingPathTranslationID = props.trainingTranslation?.id;
      module.moduleDuration = getCourseTimeString(0, 0);
      httpClient.current
        ?.post(`/module`, module, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          getModuleListByTrainingPathTranslationID();
          setSectionAddModule(false);
          setIsUpdate(false);
          setModuleTitle("");
        });
    } else if (moduleTitle.length > 2 && !isTrainingPathUpdate) {
      setModules([
        ...modules,
        {
          id: modules.length + 1,
          title: moduleTitle,
          orderOnPath: 0,
          moduleDuration: "0 min",
          trainingPathTranslationID: 0,
          courseDtoList: [],
        },
      ]);
      setModuleTitle("");
      setIsUpdate(false);
      setSectionAddModule(false);
    }
  };

  const modeUpdatingModule = (module: ModuleDto) => {
    setIsUpdate(true);
    setSectionAddModule(true);
    setModuleTitle(module.title);
    setUpdatedModule(module);
  };

  const onModuleChanged = (e: any) => {
    setModuleTitle(e.currentTarget.value);
  };

  const isDispalyedFinishButton = (): boolean => {
    if (props.isAllLanguages && props.activeStep === 1) return true;
    if (!props.isAllLanguages && props.activeStep === 0) return true;
    return false;
  };

  const isDispalyedBackButton = (): boolean => {
    if (props.isAllLanguages && props.activeStep === 1) return true;
    return false;
  };

  const handleChangeStatus = ({ file }, status) => {
    if (status === "done") {
      props.handleSupportChange(file);
      setCurrentSupportName(file.name);
    }
  };

  const deleteCurrentSupport = () => {
    setCurrentSupportName(null);
    if (props.trainingTranslation) {
      props.trainingTranslation.supportPath = null;
      props.addTrainingPathTranslation(props.trainingTranslation);
    }
  };

  const getSupportFileOriginalName = (path: string): string => {
    if (!path) {
      return null;
    }
    const extention = path.split(".").pop();
    const pathSplit = path.split("/");
    const generatedFileName = pathSplit[pathSplit.length - 1];
    const generationSplit = generatedFileName.split("_");
    return generatedFileName.replace("_" + generationSplit[generationSplit.length - 1], "") + "." + extention;
  };

  const truncate = (fileName: string) => {
    const displayName = ("  " + fileName).slice(1);
    return displayName.length > 60 ? displayName.substr(0, 59) + "..." : displayName;
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <Form className="needs-validation" id={styles["training-form"]} noValidate={true}>
            <Row>
              <Col md="6 mb-3">
                <FormGroup>
                  <Label htmlFor="validationCustom01">{props.t("Title")}</Label>
                  <input type="text" className="form-control" {...register("title", { required: true })} readOnly={props.disabled} />
                  {errors.title && <p className={styles["errorMessage"]}>*Le titre est obligatoire.</p>}
                </FormGroup>
              </Col>
              <Col md="6 mb-3">
                <FormGroup>
                  <Label htmlFor="validationCustom01">{props.t("cycle_description")}</Label>
                  <textarea className="form-control" rows={2} {...register("description", { required: true })} readOnly={props.disabled}></textarea>
                  {errors.description && <p className={styles["errorMessage"]}>*La description de parcours est obligatoire.</p>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6 mb-3">
                <FormGroup>
                  <Label htmlFor="validationCustom02">{props.t("Prerequisites")}</Label>
                  <textarea className="form-control" {...register("preRequest", { required: false })} readOnly={props.disabled}></textarea>
                </FormGroup>
              </Col>
              <Col md="6 mb-3">
                <FormGroup>
                  <Label htmlFor="validationCustom02">{props.t("target_capacity")}</Label>
                  <textarea className="form-control" {...register("capacity", { required: false })} readOnly={props.disabled}></textarea>
                </FormGroup>
              </Col>
            </Row>

            <Row className={styles["addContents"]}>
              <Card className={styles["addModuleCard"]}>
                <CardBody className={styles["addModuleCardBody"]}>
                  <Col>
                    <Row id={styles["margin_buttom"]}>
                      <Col>
                        <h5>{props.t("list_of_modules")}</h5>
                      </Col>
                      {!sectionAddModule && !props.disabled && (
                        <Col sm="4" className="text-right">
                          <i
                            id={styles["add_module_icon"]}
                            title="Créer un nouveau module"
                            className="fa fa-plus-circle fa-font-size text-success"
                            aria-disabled={props.disabled}
                            onClick={() => {
                              setSectionAddModule(true);
                              setIsUpdate(false);
                              setModuleTitle("");
                              setUpdateButton("Ajouter");
                            }}
                          ></i>
                        </Col>
                      )}
                    </Row>
                    {sectionAddModule && !props.disabled && (
                      <Row>
                        <Col md={12} className={styles["margin_buttom"]}>
                          <Input className="ng-untouched ng-pristine ng-valid" placeholder={`${props.t("module_name")}`} value={moduleTitle} onChange={onModuleChanged} />
                        </Col>
                        <Col md={12} className={styles["margin_buttom"]}>
                          <ButtonComponent
                            onClick={() => {
                              if (!isUpdate) {
                                addNewModule();
                                setUpdateButton("Ajouter");
                              } else {
                                updateModule();
                                setUpdateButton("Modifier");
                              }
                            }}
                            disable={moduleTitle.length < 3}
                            buttonType="button"
                            buttonText={updateButton}
                            save={true}
                          />
                          <ButtonComponent
                            onClick={() => {
                              setSectionAddModule(false);
                              setModuleTitle("");
                              setIsUpdate(false);
                              setUpdateButton("Ajouter");
                            }}
                            disable={false}
                            buttonType="button"
                            buttonText={(props.t("cancel")).toString()}
                            save={false}
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>

                  <Accordion className={styles["scroll"]}>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                      <Droppable droppableId="characters">
                        {provided => (
                          <ul className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                            {modules.map((module, index) => {
                              return (
                                <Draggable key={module.id.toString()} draggableId={module.id.toString()} index={index}>
                                  {provided => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                      <div className="characters-thumb">
                                        <Card>
                                          <CardHeader className="bg-primary" id={styles["addCardHeader"]}>
                                            <h3 className="mb-0">
                                              <Accordion.Toggle
                                                id={styles["blackpolice"]}
                                                className="btn txt-white"
                                                color="primary"
                                                eventKey={`${index}`}
                                                onClick={() => titleClicked(`toggleArrow${module.id}`)}
                                              >
                                                {module.title}
                                              </Accordion.Toggle>
                                              <Accordion.Toggle className={styles["iconToggle"]} eventKey={`${index}`} onClick={handleClicked}>
                                                <i className={"fa fa-chevron-down"} id={`toggleArrow${module.id}`}></i>
                                              </Accordion.Toggle>
                                              {!props.disabled && (
                                                <>
                                                  <i
                                                    className="fa fa-trash-o"
                                                    id={styles["action_icon"]}
                                                    onClick={() => {
                                                      SweetAlert.fire({
                                                        title: "Êtes-vous sûr que vous voulez supprimer ce module?",
                                                        cancelButtonText: (props.t("cancel")).toString(),
                                                        confirmButtonText: "Supprimer !",
                                                        reverseButtons: true,
                                                        showCancelButton: true,
                                                        icon: "warning",
                                                      }).then(async result => {
                                                        if (result.isConfirmed) {
                                                          await deleteModule(module.id).then(() => {
                                                            Swal.fire("Module Bien Supprimé!", "", "success");
                                                          });
                                                        }
                                                      });
                                                    }}
                                                  ></i>
                                                  <i
                                                    id={styles["action_icon"]}
                                                    className="fa fa-edit"
                                                    onClick={() => {
                                                      modeUpdatingModule(module);
                                                      setUpdateButton("Modifier");
                                                    }}
                                                  ></i>
                                                </>
                                              )}

                                              <p className={styles["duration_div"]}>{props?.trainingTranslation ? module.moduleDuration : getModuleDuration(module.id)}</p>
                                            </h3>
                                          </CardHeader>
                                          <Accordion.Collapse eventKey={`${index}`}>
                                            <CourseList
                                              key={module.id}
                                              coursesListDisplayType={CoursesListDisplayType.TABLE}
                                              moduleId={module.id}
                                              isTrainingPathUpdate={isTrainingPathUpdate}
                                              courseDtoList={module.courseDtoList}
                                              addCourseToModule={addCourseToModule}
                                              updateCourseInModuleList={updateCourseInModuleList}
                                              deleteCourseInModuleList={deleteCourseInModuleList}
                                              reloadData={reloadData}
                                              disabled={props.disabled}
                                            />
                                          </Accordion.Collapse>
                                        </Card>
                                      </div>
                                    </li>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </Accordion>
                  {modules.length === 0 && !sectionAddModule && <p className={styles["empty_modules_message"]}>{props.t("please_add_new_module")}</p>}
                </CardBody>
              </Card>
            </Row>
            <Row>
              <Col md={12}>
                <h6>Evaluation :</h6>
              </Col>
              <Col md={12}>
                <FormGroup className={styles["drop_zone_formgroup"]}>
                  {!currentSupportName && (
                    <Dropzone
                      addClassNames={{ dropzone: styles.Dropzone, input: styles.Input, inputLabel: styles.InputLabel }}
                      key="in"
                      onChangeStatus={handleChangeStatus}
                      maxFiles={1}
                      multiple={false}
                      canCancel={true}
                      canRemove={true}
                      accept=".pdf,.docx"
                      inputContent={
                        <div>
                          <span className={styles["dropzone_content_text"]}>
                            <i className="fa fa-plus"></i> {props.t("Choose_support")}
                          </span>
                        </div>
                      }
                    />
                  )}
                  {currentSupportName && (
                    <Row className={styles["pdf-container"]}>
                      <Col md={8} className={styles["pdf-title-col"]}>
                        <span>{truncate(currentSupportName)}</span>
                      </Col>
                      <Col md={2} className={styles["icon-col"]}>
                        <Media body src={currentSupportName.endsWith("pdf") ? pdfLogo : wordLogo} className={styles["pdf_logo"]} />
                      </Col>
                      <Col md={2}>
                        <span onClick={deleteCurrentSupport} className={styles["icon-delete"]}>
                          <i className="fa fa-times-circle"></i>
                        </span>
                      </Col>
                    </Row>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row className={styles["buttons_position"]}>
              {isDispalyedBackButton() && <ButtonComponent onClick={() => props.handleBack()} disable={false} buttonType="button" buttonText={String(props.t("previous"))} save={false} />}
              {props.activeStep < 1 && props.isAllLanguages && (
                <ButtonComponent
                  onClick={() => {
                    props.handleNext();
                    preSaveTrainingPathTranslation();
                  }}
                  disable={!isValid || !currentSupportName}
                  buttonType="button"
                  buttonText={String(props.t("next"))}
                  save={true}
                />
              )}
              {isDispalyedFinishButton() && (
                <ButtonComponent
                  onClick={() => {
                    props.handleNext();
                    preSaveTrainingPathTranslation();
                  }}
                  disable={!isValid || !currentSupportName}
                  buttonType="button"
                  buttonText={String(props.t("finish"))}
                  save={true}
                />
              )}
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default translate(TrainingPathTranslationForm);
